import { JSX } from 'react'

type SquaredIconProps = {
  icon: JSX.Element
}
export const SquaredIcon = ({ icon }: SquaredIconProps) => {
  return <div className="squared-icon">{icon}</div>
}
